import React from "react"


export const About = () => (
<div className="mx-5">
    <h1>About</h1>
    <p>Baristapp is the industry’s leading online barista training provider. 
        Our portfolio of educational resources and barista classes have reached over a million unique viewers.
         All our coffee based barista training is centred around engagement and innovation. 
         We have a barista course for every aspect of the specialty coffee industry, 
         from milk science and latte art, to advanced coffee making. In our huge video archive, 
        you will find a collection of barista training videos relating to all areas of the coffee world.</p>
  </div>)
    